import { BaseMeasures } from './BaseMeasures';

class SSRMeasure extends BaseMeasures {
	private startTimeOffset: number = 0;
	private startTime: number = 0;
	private fetchCount: number = 0;

	public fetchCountIncr() {
		this.fetchCount++;
	}

	public getFetchCount() {
		return this.fetchCount;
	}

	public setStartTime(startTimeOffset: number = 0): void {
		this.startTimeOffset = startTimeOffset;
		if (!this.startTime) {
			this.startTime = Math.floor(performance.now());
		}
	}

	public getStartTime() {
		return this.startTime;
	}

	public nowFromStartTime() {
		return Math.floor(performance.now()) - this.startTime;
	}

	private now() {
		return this.nowFromStartTime() + this.startTimeOffset;
	}

	override markMeasureStart(name: string) {
		if (!this.measures[name]) {
			this.measures[name] = {
				startTime: this.now(),
				duration: 0,
			};
		}
	}

	override markMeasureEnd(name: string) {
		const entry = this.measures[name];
		if (entry) {
			entry.duration = this.now() - entry.startTime;
		}
	}

	override clearMeasures(): void {
		this.startTimeOffset = 0;
		this.startTime = 0;
		this.fetchCount = 0;
		this.measures = {};
	}
}

export const SSRMeasures = new SSRMeasure();
